import { AfterViewInit, Component, ElementRef, Input, Output, EventEmitter, OnInit, NgModule, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { StarratingRoutingModule } from './starrating.routing.module';

@Component({
  selector: 'starrating',
  template: `
  <div class="md-form d-none d-lg-block" *ngIf="visible && form.controls[name]" [formGroup]="form" style="text-align: center;font-size: 12px;">  
    <label *ngIf="caption" class="active"><em>{{caption}}</em></label>
    <i [ngClass]="getClass(0)"></i>
    <i [ngClass]="getClass(25)"></i>
    <i [ngClass]="getClass(50)"></i>
    <i [ngClass]="getClass(75)"></i>
    <i [ngClass]="getClass(100)"></i>
  </div>`,
  encapsulation: ViewEncapsulation.None,
})

export class StarratingComponent implements OnInit {
  @Input() public name: string = '';
  @Input() public caption: string = '';
  public readonly: boolean = false;
  @Input() public control: AbstractControl;
  @Input() public enabled: boolean = false;
  @Input() public visible: boolean = true;
  @Output() public valueChange = new EventEmitter<string>();
  @Input() public form: FormGroup;
  public elementRef: ElementRef;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit(): void {
    if (!this.control) {
      if (this.form.controls[this.name] == null) {
        this.control = new FormControl();
        this.form.addControl(this.name, this.control);
      }
      this.control = this.form.controls[this.name];
    }
    this.control.valueChanges.subscribe((value) => {
    });
  }

  setValue(value: string) {
    this.control.patchValue(value);
  }

  getClass(value: number): string {
    let className: string = '-text';
    if (this.control.value < 25) {
      className = 'red' + className;
    } else if (this.control.value < 50) {
      className = 'orange' + className;
    } else if (this.control.value < 75) {
      className = 'yellow' + className;
    } else if (this.control.value <= 100) {
      className = 'green' + className;
    }
    if (this.control.value > value ||  this.control.value == 100) {
      className = className + ' ' + 'fa fa-star';
    } else {
      className = className + ' ' + 'fa fa-star-o';
    }
    return className;
  }
}
